window.editFormatter = function(value, row) {
    let html = '';
    if (row.allow_edit === "0") {
        return html;
    }
    html += '<a href="#" class="action action-edit">';
    html += '<i class="fa fa-pencil"></i>';
    html += '</a>';
    return html;
};
